import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { router } from './router';
import { TourProvider } from './components/tour/TourProvider';

// Single QueryClient for the app. Defaults are tuned for B2B ordering:
// - 60s staleTime: catalog and AR data are fine for a minute.
// - retry: 1: surface real errors quickly instead of hiding behind retries.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TourProvider>
        <RouterProvider router={router} />
      </TourProvider>
    </QueryClientProvider>
  );
}
